import { render, staticRenderFns } from "./FeaturesTable.vue?vue&type=template&id=cc275c06"
import script from "./FeaturesTable.vue?vue&type=script&lang=js"
export * from "./FeaturesTable.vue?vue&type=script&lang=js"
import style0 from "./FeaturesTable.vue?vue&type=style&index=0&id=cc275c06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports